module.exports = __webpack_public_path__ + "static/barcelona_code_school_logo-7c818a1ecc94984bc224facb453c6d81.png";